// Mapa exhaustivo de keywords → ejercicios reales de currentExcersices.js
// Cubre EX21 (Excel Básico), EI23 (Excel Intermedio), EA16 (Excel Aplicado)
// detectExcelExercise() lo usa ChatPanel para sugerir ejercicio al terminar respuesta.

import {
  EJERCICIO_REFERENCIAS,
  EJERCICIO_TEXTO,
  EJERCICIO_VALIDACION,
  EJERCICIO_ESTADISTICAS,
  EJERCICIO_FECHASSIMPLES,
  EJERCICIO_PORCENTAJES,
  EJERCICIO_BUSCARV,
  EJERCICIO_SUMARSI,
  EJERCICIO_FECHAS,
  EJERCICIO_INDICECOINCIDIR,
  EJERCICIO_TEXTOAVANZADO,
  EJERCICIO_SIYO,
  EJERCICIO_FACTURACION,
  EJERCICIO_SIERROR,
  EJERCICIO_CUENTASCOBRAR,
  EJERCICIO_NOMINA,
  EJERCICIO_CRM,
  EJERCICIO_COMISIONES,
} from './currentExcersices';

function norm(str) {
  return str.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
}

// ─── Mapa keyword → ejercicio ─────────────────────────────────────────────────
// Orden importa: primer match gana.
// Keywords separadas = frase exacta a buscar en la query normalizada.

const MAP = [

  // ── REFERENCIAS ABSOLUTAS / RELATIVAS / MIXTAS (EX2103) ──────────────────
  // También cubre: operadores, fórmulas matemáticas, aritmética básica
  {
    exercise: EJERCICIO_REFERENCIAS,
    label: 'Referencias Absolutas ($)',
    keywords: [
      // referencias
      'referencia absoluta','referencia relativa','referencia mixta',
      'referencias absolutas','referencias relativas','referencias mixtas',
      'fijar celda','fijar una celda','bloquear celda','simbolo dolar',
      'copiar formula','copiar formulas','arrastrar formula',
      // operadores y matemáticas (EX2103 Operadores, Funciones Matemáticas)
      'operadores en excel','formula matematica','formulas matematicas',
      'multiplicar en excel','dividir en excel','sumar celdas',
      'operacion basica',
      'como hacer una formula','insertar formula','parentesis en excel',
      'tipos de funciones','funciones matematicas excel',
      // referencia entre hojas / libros (EX2103)
      'referencia entre hojas','referencia entre libros','vincular hojas',
    ],
  },

  // ── FUNCIONES DE TEXTO BÁSICAS (EX2103) ───────────────────────────────────
  // NOTA: LARGO, EXTRAE, HALLAR y SUSTITUIR se movieron a "Funciones de Texto
  // Avanzadas" (Intermedio) porque son las que ese ejercicio realmente enseña.
  {
    exercise: EJERCICIO_TEXTO,
    label: 'Funciones de Texto',
    keywords: [
      'concatenar','mayusc','minusc','izquierda','derecha',
      'nompropio','recortar','espacios en blanco',
      'unircadenas','funcion concat','texto a columnas','separar texto',
      'combinar texto','unir texto','juntar nombres',
      'funcion de texto','manipular texto',
      'convertir a mayusculas','upper excel','left excel','right excel',
      'trim excel','texto a numero','numero a texto',
    ],
  },

  // ── DUPLICADOS / FILTROS / VALIDACIÓN DE DATOS (EX2104, EI2301) ──────────
  // Cubre: quitar duplicados, filtros, validación, formato condicional, ordenar
  {
    exercise: EJERCICIO_VALIDACION,
    label: 'Duplicados con CONTAR.SI',
    keywords: [
      // duplicados
      'duplicado','duplicados','valores duplicados','datos duplicados',
      'quitar duplicados','eliminar duplicados','detectar duplicados',
      'datos repetidos','registros repetidos','valores repetidos',
      // filtros (EX2104)
      'filtros en excel','aplicar filtro','quitar filtro','filtro avanzado',
      'filtro por color','reglas de filtro','filtros dinamicos',
      'funcion filtrar','filtrar datos','valores unicos con filtrar',
      // ordenar (EX2104)
      'ordenar datos','ordenar lista','ordenar por niveles','orden personalizado',
      'ordenar por color','funcion ordenar','funcion ordenarpor',
      // validación de datos (EX2104)
      'validacion de datos','lista desplegable','lista de opciones',
      'validar captura','validar entrada','menu desplegable',
      'evitar duplicados en formulario',
      // formato condicional (EX2102, EI2301)
      'formato condicional','resaltar celdas','color segun valor',
      'mayor que menor que','resaltar fechas vencidas','escala de colores',
      'barra de datos','conjunto de iconos',
      // comparar columnas (EI2301)
      'comparar dos columnas','comparar columnas','diferencias entre columnas',
      // datos limpios generales
      'limpiar datos','datos limpios','preparar datos','depurar datos',
      'celdas en blanco','rellenar celdas vacias','ir a especial',
    ],
  },

  // ── FUNCIONES ESTADÍSTICAS BÁSICAS: MAX, MIN, PROMEDIO, CONTAR (EX2103) ──
  {
    exercise: EJERCICIO_ESTADISTICAS,
    label: 'Funciones Estadísticas',
    keywords: [
      'funcion max','funcion min','maximo y minimo','valor maximo','valor minimo',
      'calcular promedio','promedio de calificaciones','promedio de notas',
      'estadisticas basicas','funciones estadisticas','resumen estadistico',
      'calificacion mas alta','calificacion mas baja','nota maxima','nota minima',
      'funcion contar numeros','contar calificaciones','contar valores numericos',
    ],
  },

  // ── FECHAS SIMPLES: resta de fechas (EX2103) ─────────────────────────────
  // NOTA: keywords muy específicas para no competir con "Cálculo de
  // Vencimientos" (Intermedio), que ya cubre las frases genéricas de fechas.
  {
    exercise: EJERCICIO_FECHASSIMPLES,
    label: 'Fechas Simples',
    keywords: [
      'dias para entregar','tiempo de entrega','calcular tiempo de entrega',
      'dias que tardo un pedido','resta simple de fechas',
      'diferencia simple de fechas','fecha de compra y entrega',
    ],
  },

  // ── PORCENTAJES Y DESCUENTOS (EX2102) ────────────────────────────────────
  {
    exercise: EJERCICIO_PORCENTAJES,
    label: 'Porcentajes y Descuentos',
    keywords: [
      'calcular porcentaje','calcular descuento','aplicar descuento',
      'precio con descuento','porcentaje de descuento','sacar porcentaje',
      'calcular iva','aplicar iva','precio final con descuento',
      'ofertas y descuentos','descuentos en excel','regla de tres en excel',
    ],
  },

  // ── BUSCARV / BUSCARX (EI2302) ────────────────────────────────────────────
  // NOTA: "índice y coincidir" se movió a su propio ejercicio dedicado — BUSCARV
  // no enseña esa combinación, aunque resuelva un problema parecido.
  {
    exercise: EJERCICIO_BUSCARV,
    label: 'BUSCARV',
    keywords: [
      // buscarv
      'buscarv','vlookup','buscar v','buscarv en excel',
      'funcion buscarv','como usar buscarv','buscarv ejemplo',
      // buscarx
      'buscarx','xlookup','buscar x','buscarv vs buscarx',
      'busquedas aproximadas','busqueda aproximada',
      // búsqueda general
      'buscar en tabla','encontrar valor','busqueda en tabla',
      'buscar dato','traer dato','obtener valor de tabla',
      'buscar informacion','buscar precio','buscar nombre',
      'funcion de busqueda','funciones de busqueda',
      // desref (EI2302)
      'desref','offset excel','sumar periodos','rango dinamico',
    ],
  },

  // ── SUMAR.SI / CONTAR.SI (EI2302) ─────────────────────────────────────────
  // NOTA: NO incluye tablas dinámicas ni dashboards, ni SUMAPRODUCTO/PROMEDIO.SI/
  // MAX.SI.CONJUNTO — el motor y este ejercicio no los implementan; mapearlos
  // aquí generaba una tarjeta con un título que no correspondía a lo preguntado.
  {
    exercise: EJERCICIO_SUMARSI,
    label: 'SUMAR.SI y CONTAR.SI',
    keywords: [
      // sumar.si
      'sumar.si','sumif','sumar si','suma condicional','suma con condicion',
      'sumar por categoria','sumar por region','sumar por criterio',
      // contar.si (cuando no es para duplicados)
      'contar.si','countif','contar con condicion','contar por categoria',
      'contar con criterios',
      // resumen de datos / agrupación
      'agrupar datos','totalizar por grupo','resumen por categoria',
      'subtotales','calcular subtotales','sumar por grupo',
      // acumular totales (EI2301)
      'acumular totales','totales acumulados','suma acumulada','total acumulado',
    ],
  },

  // ── FECHAS / VENCIMIENTOS / TIEMPO (EX2103, EI2302, EA1610) ─────────────
  {
    exercise: EJERCICIO_FECHAS,
    label: 'Cálculo de Vencimientos',
    keywords: [
      // fechas básicas (EX2103)
      'calcular fechas','funciones de fecha','restar fechas','dias entre fechas',
      'fecha en excel','trabajar con fechas','formato de fecha',
      'hoy()','ahora()','funcion hoy','funcion ahora','fecha actual',
      // partes de fecha (EI2302)
      'año()','mes()','dia()','extraer año','extraer mes','extraer dia',
      'nombre del mes','obtener mes','funcion texto fecha',
      'dias.lab','dias laborables','dias habiles','calcular dias habiles',
      // calcular edad (EI2302)
      'calcular edad','edad en excel','cuantos años tiene','diferencia de fechas',
      'datedif','sifecha','funcion sifecha',
      // vencimientos / plazos
      'vencimiento','vencimientos','fecha de vencimiento','dias de vencimiento',
      'dias transcurridos','calcular dias','plazo','fecha vencida','fecha vigente',
      'alertas de vencimiento',
      // suma horas (EI2302)
      'suma con horas','sumar horas','formato de horas','calcular horas',
      'hora en excel','tiempo en excel',
      // cronograma / calendario (EI2302, EI2308)
      'cronograma','linea del tiempo','calendarizar','programar fechas',
    ],
  },

  // ── ÍNDICE y COINCIDIR (EI2302) ──────────────────────────────────────────
  {
    exercise: EJERCICIO_INDICECOINCIDIR,
    label: 'ÍNDICE y COINCIDIR',
    keywords: [
      'indice y coincidir','indice coincidir','index match',
      'funcion indice','funcion coincidir','coordenadas en excel',
      'busqueda bidireccional','busqueda en dos columnas',
      'busqueda flexible',
      'indice()','coincidir()','funcion index','funcion match',
    ],
  },

  // ── FUNCIONES DE TEXTO AVANZADAS: LARGO, EXTRAE, HALLAR, SUSTITUIR (EI2302) ──
  {
    exercise: EJERCICIO_TEXTOAVANZADO,
    label: 'Funciones de Texto Avanzadas',
    keywords: [
      'largo en excel','funcion largo','longitud de texto','len funcion',
      'verificar longitud','contar caracteres','medir texto',
      'extrae','funcion extrae','mid excel','extraer parte de un texto',
      'hallar','funcion hallar','buscar posicion de texto','search excel',
      'sustituir','funcion sustituir','reemplazar texto','buscar y reemplazar',
      'quitar guiones','limpiar telefono','limpiar formato de texto',
      'funciones de texto avanzadas','texto avanzado excel',
    ],
  },

  // ── LÓGICA COMBINADA: SI + Y() + O() (EI2302) ────────────────────────────
  {
    exercise: EJERCICIO_SIYO,
    label: 'Lógica Combinada: SI, Y y O',
    keywords: [
      'si y y o','combinar y y o','y y o en excel','funcion y y funcion o juntas',
      'regla con dos condiciones','regla de negocio con condiciones',
      'aprobar con dos materias','elegibilidad con requisitos',
      'al menos una condicion','todas las condiciones deben cumplirse',
    ],
  },

  // ── FACTURACIÓN / INVENTARIO / GESTIÓN EMPRESARIAL (EA1608, EA1609) ──────
  {
    exercise: EJERCICIO_FACTURACION,
    label: 'Facturación con BUSCARV',
    keywords: [
      // facturación
      'factura','facturas','facturacion','crear factura','factura en excel',
      'precio unitario','subtotal','total factura','monto factura',
      'catalogo de precios','lista de precios','tabla de precios',
      // inventario
      'inventario','control de inventario','control de stock','kardex',
      'entradas salidas','saldo en bodega','bodega','almacen',
      'control de existencias','codigo de barras','registro de productos',
      // ventas/compras (EA1608)
      'registro de ventas','control de ventas','ventas en excel',
      'registro de compras','control de compras','pedidos',
      'control de pedidos','seguimiento de pedidos',
      // gestión empresarial general
      'gestion empresarial','sistema de control','reporte de ventas',
      'reporte empresarial','hoja de control','formato de control',
      // base de datos excel (EA1601)
      'base de datos','funciones de base de datos','bbdd excel',
      'filtros avanzados','funcion bdcontar','funcion bdsuma',
    ],
  },

  // ── SI.ERROR / MANEJO DE ERRORES / FUNCIONES ANIDADAS (EI2302, EA1613) ──
  // NOTA: "validar RFC" y LARGO() se movieron a "Funciones de Texto Avanzadas"
  // — SI.ERROR no mide texto, solo envuelve fórmulas que pueden fallar.
  {
    exercise: EJERCICIO_SIERROR,
    label: 'Manejo de Errores (SI.ERROR)',
    keywords: [
      // si.error
      'si.error','iferror','sierror','si error','manejar errores',
      'ocultar errores','errores en excel','error en formula',
      'no encontrado','valor no encontrado','resultado no encontrado',
      // tipos de errores
      '#n/a','#valor','#ref','#div/0','#nombre','#nulo',
      'error na','error valor','error ref','error div','error nombre',
      'cuando no encuentra','si no encuentra',
      // funciones anidadas (EI2302)
      'funciones anidadas','anidar funciones','funcion dentro de funcion',
      'introduccion funciones anidadas','formulas complejas',
      // si.nd, si.conjunto
      'si.nd','ifna','funcion si.nd',
    ],
  },

  // ── SI ANIDADO / CUENTAS POR COBRAR / LÓGICA MÚLTIPLE (EA1610, EI2302) ──
  {
    exercise: EJERCICIO_CUENTASCOBRAR,
    label: 'Cuentas por Cobrar',
    keywords: [
      // cuentas por cobrar / cobranza
      'cuentas por cobrar','cobranza','credito','cartera',
      'estado de cuenta','por vencer','vencida','vigente',
      'seguimiento de pagos','dias de credito',
      // SI anidado
      'si anidado','anidar si','if anidado','si dentro de si',
      'multiples condiciones','varias condiciones','condicion compuesta',
      'tercera categoria','tres categorias','tres opciones',
      // Y / O (AND / OR) — se evitan formas cortas como "o excel"/"y excel":
      // como substrings sin límite de palabra, coinciden con cualquier texto
      // que termine en "o"/"y" seguido de "excel" (p.ej. "descuento en excel").
      'funcion y()','funcion o()','and excel',
      'condicion y','condicion o',
      'todas las condiciones','alguna condicion','ambas condiciones',
      // SI.CONJUNTO / CAMBIAR (EI2302)
      'si.conjunto','ifs excel','funcion si conjunto','multiples si',
      'funcion cambiar','switch excel','reemplazar si anidado',
      // clasificar / categorizar
      'clasificar datos','categorizar','etiquetar registros','asignar categoria',
      'semaforo en excel','clasificacion automatica','rangos de clasificacion',
      // depreciacion (EI2302)
      'depreciacion','amortizacion','valor residual',
    ],
  },

  // ── NÓMINA: bonos por desempeño y resumen por departamento (EA1612) ─────
  {
    exercise: EJERCICIO_NOMINA,
    label: 'Nómina: Bonos y Deducciones',
    keywords: [
      'nómina en excel','calcular nómina','bono por desempeño','bono de productividad',
      'liquidar nómina','deducciones de nómina','sueldo por departamento',
      'resumen de nómina','gestion humana excel','recursos humanos excel','nomina en excel','calcular nomina', 'nomina', 'nómina    '
    ],
  },

  // ── CRM: búsqueda y clasificación de leads (EA1611) ──────────────────────
  {
    exercise: EJERCICIO_CRM,
    label: 'CRM: Clasifica tus Leads',
    keywords: [
      'crm en excel','clasificar leads','clasificar prospectos','priorizar prospectos',
      'seguimiento de prospectos','base de prospectos','interes de un prospecto',
      'diseño de crm','prioridad de contacto', 'crm', 'CRM', 'CRM en Excel',
    ],
  },

  // ── COMISIONES DE VENTA: reporte integrador (EA1613) ─────────────────────
  {
    exercise: EJERCICIO_COMISIONES,
    label: 'Comisiones de Venta',
    keywords: [
      'comisiones de venta','calcular comisiones','comision por vendedor',
      'reporte de comisiones','cumplimiento de meta de ventas','meta de ventas excel',
      'porcentaje de comision','integrar varias funciones',
    ],
  },

];

// ─── Detección ────────────────────────────────────────────────────────────────

export function detectExcelExercise(query) {
  const q = norm(query);
  for (const entry of MAP) {
    if (entry.keywords.some((k) => q.includes(norm(k)))) return entry;
  }
  return null;
}

// Rehydrata un match { exercise, label } a partir de su label — el objeto exercise
// original trae funciones (check) que no sobreviven un JSON.stringify en localStorage.
export function getExerciseByLabel(label) {
  return MAP.find((entry) => entry.label === label) || null;
}
